import { render, staticRenderFns } from "./DynamicArray.vue?vue&type=template&id=401670a4&scoped=true"
import script from "./DynamicArray.vue?vue&type=script&lang=js"
export * from "./DynamicArray.vue?vue&type=script&lang=js"
import style0 from "./DynamicArray.vue?vue&type=style&index=0&id=401670a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401670a4",
  null
  
)

export default component.exports